import React, { useContext, useEffect, useState } from "react";
import {
  Table,
  TableHeader,
  TableCell,
  TableFooter,
  TableContainer,
  Select,
  Input,
  Button,
  Card,
  CardBody,
  Pagination,
} from "@windmill/react-ui";
import { useTranslation } from "react-i18next";
import { FiPlus } from "react-icons/fi";

import useAsync from "hooks/useAsync";
import useToggleDrawer from "hooks/useToggleDrawer";
import UploadManyTwo from "components/common/UploadManyTwo";
import NotFound from "components/table/NotFound";
// import ProductServices from "services/ProductServices";
import PageTitle from "components/Typography/PageTitle";
import { SidebarContext } from "context/SidebarContext";
import CheckBox from "components/form/CheckBox";
import useProductFilter from "hooks/useProductFilter";
import TableLoading from "components/preloader/TableLoading";
import SettingServices from "services/SettingServices";
import HistoryTable from "components/history/HistoryTable";
import HistoryServices from "services/HistoryServices";

import * as XLSX from 'xlsx';

import ReactExport from "react-export-excel";
import { jsPDF } from "jspdf";
import 'jspdf-autotable';


const History = () => {
  const { id,title, subtitle, short_description, description, allId, serviceId, handleDeleteMany, handleUpdateMany } =
    useToggleDrawer();
  const { t } = useTranslation();
  const {
    toggleDrawer,
    lang,
    currentPage,
    handleChangePage,
    searchText,
    category,
    setCategory,
    searchRef,
    handleSubmitForAll,
    sortedField,
    setSortedField,
    limitData,
  } = useContext(SidebarContext);

  const [data, setData] = useState([]);
  const [isLoading, setIsLoading]=useState(true);


  const [exportData, setExportData] = useState([]);
  const exportToExcel = () => {
    const dataSet = exportData.map(item => ({
      Id: item.id,
      Admin_Name:item.admin.name,
      Action:item.action,
      Description:item.description,
    }));

    const ws = XLSX.utils.json_to_sheet(dataSet);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "histories");
    XLSX.writeFile(wb, "histories.xlsx");
  };

  const exportToCSV = () => {
    const csvData = exportData.map(item => [
      item.id,
      item.admin.name,
      item.action,
      item.description,
    ]);

    const csvContent = "data:text/csv;charset=utf-8," + csvData.map(e => e.join(",")).join("\n");
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "histories.csv");
    document.body.appendChild(link);
    link.click();
  };

  const exportToPDF = () => {
    const doc = new jsPDF();
    doc.autoTable({
      head: [[t("ID"), t("ADMINNAMETbl"), t("ACTIONTbl"),t("DESCRIPTIONTbl")]],
      body: exportData.map(item => [
        item.id,
        item.admin.name,
        item.action,
        item.description,
      ]),
    });
    doc.save('histories.pdf');
  };

  useEffect(() => {
    setExportData(data);
  }, [data]);

  // Utilisez la fonction getAllServices pour récupérer les données des projets depuis l'API
  const fetchHistory = async (isLoading) => {
    try {
      
      const response = await HistoryServices.getAllHistory();
    
      // Mettez à jour la variable data avec les données récupérées
      setData(response.data);
    } catch (error) {
      console.error("Erreur lors de la récupération  :", error);
    }
    finally {
      setIsLoading(false); // Mettre à jour l'état pour indiquer que le chargement est terminé
    }
  };
  
  useEffect(() => {
  fetchHistory(isLoading); // Appelez la fonction fetchHistory pour récupérer les projets au chargement du composant
}, [isLoading]); // Utilisez une dépendance vide pour que cela ne s'exécute qu'une fois au chargement du composant
  // console.log("product page", data);
  // react hooks
  const [isCheckAll, setIsCheckAll] = useState(false);
  const [isCheck, setIsCheck] = useState([]);

  const handleSelectAll = () => {
    setIsCheckAll(!isCheckAll);
    setIsCheck(data?.Services.map((li) => li._id));
    if (isCheckAll) {
      setIsCheck([]);
    }
  };

  // console.log('productss',products)
  const {
    serviceData,
    filename,
    isDisabled,
    handleSelectFile,
    handleUploadMultiple,
    handleRemoveSelectFile,
  } = useProductFilter(data?.Services);

  return (
    <>
      <PageTitle>{t("HistoryPage")}</PageTitle>
      
      <Card className="min-w-0 shadow-xs overflow-hidden bg-white dark:bg-gray-800 mb-5">
        <CardBody className="">
          <form
            onSubmit={handleSubmitForAll}
            className="py-3 md:pb-0 grid gap-4 lg:gap-6 xl:gap-6  xl:flex"
          > 
            <div className="flex justify-start xl:w-1/2  md:w-full">
              {/* <UploadManyTwo
                title="History"
                filename={filename}
                isDisabled={isDisabled}
                totalDoc={data?.totalDoc}
                handleSelectFile={handleSelectFile}
                handleUploadMultiple={handleUploadMultiple}
                handleRemoveSelectFile={handleRemoveSelectFile}
              /> */}
            </div>
          </form>
        </CardBody>
      </Card>

  

      {serviceData?.length !== 0 ? (
         <>
         <div className="lg:flex   md:flex s:flex xl:w-1/3 lg:justify-end space-x-1 xl:justify-end ">

           <Button
             onClick={exportToExcel}
             className="flex-1 rounded-md h-5 text-sm"
           >
             {t("Export to Excel")}
           </Button>

           <Button
             onClick={exportToCSV}
             className="flex-1 rounded-md h-5 text-sm"
           >
             {t("Export to CSV")}
           </Button>

           <Button
             onClick={exportToPDF}
             className="flex-1 rounded-md h-5 text-sm"
           >
             {t("Export to PDF")}
           </Button>

         </div>
         <br />
        <TableContainer className="mb-8 rounded-b-lg">
          <Table>
            <TableHeader>
              <tr>
            
                <TableCell>{t("ADMINNAMETbl")}</TableCell>
                <TableCell>{t("ACTIONTbl")}</TableCell>
                <TableCell>{t("DESCRIPTIONTbl")}</TableCell>
                <TableCell>{t("Date")}</TableCell>
              </tr>
            </TableHeader>
            <HistoryTable
              setIsLoading={setIsLoading}
              isLoading={isLoading}
              lang={lang}
              isCheck={isCheck}
              history={data?.history}
              setIsCheck={setIsCheck}
              data={data}
            /> 
          </Table>
          {/* <TableFooter>
            <Pagination
              totalResults={data?.totalDoc}
              resultsPerPage={limitData}
              onChange={handleChangePage}
              label="History Page Navigation"
            />
          </TableFooter> */}
        </TableContainer>
        </>
      ) : (
        <NotFound title="History" />
      )}
    </>
  );
};

export default History;
